<template>
  <Headers :page="page"> </Headers>
  <div :class="[deviceType, 'progressContainer']">
    <!-- <div class="timer">
      <img
        style="width: 20px; height: 20px"
        class="path-65"
        src="../../../assets/icons/timer.svg"
      />
      <p>{{ prop.countDown }}</p>
    </div> -->
    <div v-if="prop.status == 'success'">
      <AcknowledgementSuccess
        :webFormRequestId="webFormRequestId"
        :cardId="cardId"
        :icNo="icNo"
        :creditLimit="creditLimit"
        :refNo="prop.refNo"
        :cardName="prop.cardName"
        :score="prop.score"
        :dsr="prop.dsr"
        :preStatus="prop.preStatus"
        :type="prop.type"
        :changeApplicationFlag="prop.changeApplicationFlag"
        :token="prop.token"
        :isDraft="prop.isDraft"
      ></AcknowledgementSuccess>
    </div>
    <div v-else-if="prop.status == 'unsuccess'">
      <AcknowledgementUnsuccess :refNo="prop.refNo"></AcknowledgementUnsuccess>
    </div>
    <div v-else-if="prop.status == 'declined'">
      <AcknowledgementDeclined :refNo="prop.refNo"></AcknowledgementDeclined>
    </div>
    <div v-else-if="prop.status == 'denied'">
      <AcknowledgementDenied :refNo="prop.refNo"></AcknowledgementDenied>
    </div>
    <div v-else-if="prop.status == 'sendBack'">
      <AcknowledgementSendBack :refNo="prop.refNo"></AcknowledgementSendBack>
    </div>
    <div v-else-if="prop.status == 'expired'">
      <AcknowledgementExpired :refNo="prop.refNo"></AcknowledgementExpired>
    </div>
    <div v-else-if="prop.status == 'expiredReminderLink'">
      <ReminderLinkExpired
        :refNo="prop.refNo"
        :type="prop.type"
      ></ReminderLinkExpired>
    </div>
    <div v-else-if="prop.status == 'invalidReminderLink'">
      <ReminderLinkInvalid
        :refNo="prop.refNo"
        :type="prop.type"
      ></ReminderLinkInvalid>
    </div>
    <div v-else-if="prop.status == 'invalidLink'">
      <AcknowledgementInvalidLink></AcknowledgementInvalidLink>
    </div>
    <div v-else-if="prop.status == 'OTPMAX'">
      <AcknowledgementOtpMax :refNo="prop.refNo"></AcknowledgementOtpMax>
    </div>
    <div v-else-if="prop.status == 'cardTypeMissing'">
      <AcknowledgementMissingCardType></AcknowledgementMissingCardType>
    </div>
    <div v-else-if="prop.status == 'denied2'">
      <AcknowledgementDenied2 :refNo="prop.refNo"></AcknowledgementDenied2>
    </div>
    <div v-else-if="prop.status == 'cardApplicationUnsucessful'">
      <AcknowledgementCardApplicationUnsuccessful
        @jump-step="jumpStep"
        @set-card-id="setCardId"
        @set-card-name="setCardName"
        :selected-card="selectedCard"
        :nationality="prop.nationality"
        :grossSalary="prop.grossSalary"
        :type="prop.type"
        :webFormRequestId="webFormRequestId"
        :token="prop.token"
        :acc="prop.acc"
        @close-overlay="closeOverlay"
        @tokenSessionTimeOut="tokenSessionTimeOut"
      ></AcknowledgementCardApplicationUnsuccessful>
    </div>
    <div v-else-if="prop.status == 'cardApplicationNotQualify'">
      <AcknowledgementCardApplicationNotQualify
        @jump-step="jumpStep"
        :type="prop.type"
      ></AcknowledgementCardApplicationNotQualify>
    </div>
    <div v-else-if="prop.status == 'applicationExpired'">
      <AcknowledgementApplicationExpired
        :card-name="cardName"
        :date="prop.date"
        :time="time"
      ></AcknowledgementApplicationExpired>
    </div>
  </div>
  <div v-if="overlay" class="overlay">
    <div class="text-center flex-container">
      <p class="loading">
        <b>{{ t("ccOnBoarding.uploadDocument.loading") }}</b>
        <!-- <b>Submit Fail</b> -->
      </p>
      <br />
      <div class="spinner-border" role="status">
        <span class="sr-only">{{
          t("ccOnBoarding.uploadDocument.loading2")
        }}</span>
      </div>
      <br />
      <br />
      <p class="loading">
        <b>{{ t("ccOnBoarding.uploadDocument.loading2") }}</b>
      </p>
      <br />
      <br />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, type PropType, onBeforeMount } from "vue";
import AcknowledgementSuccess from "./components/AcknowledgementSuccess.vue";
import AcknowledgementUnsuccess from "./components/AcknowledgementUnsuccessful.vue";
import AcknowledgementDeclined from "./components/AcknowledgementDeclined.vue";
import AcknowledgementDenied from "./components/AcknowledgementDenied.vue";
import AcknowledgementDenied2 from "./components/AcknowledgementDenied2.vue";
import AcknowledgementSendBack from "./components/AcknowledgementSendBack.vue";
import AcknowledgementExpired from "./components/AcknowledgementExpired.vue";
import AcknowledgementMissingCardType from "./components/AcknowledgementMissingCardType.vue";
import AcknowledgementCardApplicationUnsuccessful from "./components/AcknowledgementCardApplicationUnsuccessful.vue";
import AcknowledgementCardApplicationNotQualify from "./components/AcknowledgementCardApplicationNotQualify.vue";
import AcknowledgementApplicationExpired from "./components/AcknowledgementApplicationExpired.vue";
import ReminderLinkExpired from "./components/ReminderLinkExpired.vue";
import ReminderLinkInvalid from "./components/ReminderLinkInvalid.vue";
import Headers from "./components/Headers.vue";
import { deviceDetect } from "mobile-device-detect";
import AcknowledgementOtpMax from "./components/AcknowledgementOtpMax.vue";
import type { Card } from "@/interface/FormCC";
import i18n from "@/plugin/i18n";
import { boolean } from "yup";
import AcknowledgementInvalidLink from "./components/AcknowledgementInvalidLink.vue";

const { t } = i18n.global;
const deviceType = ref("");
const emit = defineEmits([
  "nextStep",
  "jumpStep",
  "submit",
  "setCardId",
  "setCardName",
  "tokenSessionTimeOut",
]);

onMounted(() => {
  const { isMobile, isTablet } = deviceDetect();

  if (isMobile) {
    deviceType.value = "Mobile";
  } else if (isTablet) {
    deviceType.value = "Tablet";
  } else {
    deviceType.value = "Desktop";
  }
});

const overlay = ref(false);

onBeforeMount(() => {
  window.scrollTo({ top: 0, behavior: "smooth" });

  if (prop.status == "cardApplicationUnsucessful") overlay.value = true;
});

const closeOverlay = () => {
  overlay.value = false;
};

//success
//unsuccess
//declined

const jumpStep = (value: Number, name: string, page: string) => {
  emit("jumpStep", value, name, page);
};

const setCardId = () => {
  emit("setCardId");
};

const setCardName = () => {
  emit("setCardName");
};

const tokenSessionTimeOut = () => {
  emit("tokenSessionTimeOut");
};

const prop = defineProps({
  selectedCard: {
    type: Object as PropType<Card>,
    required: true,
  },
  status: {
    type: String,
  },
  webFormRequestId: {
    type: String,
  },
  cardId: {
    type: String,
  },
  icNo: {
    type: String,
  },
  creditLimit: {
    type: String,
  },
  refNo: {
    type: String,
  },
  cardName: {
    type: String,
    required: true,
  },
  score: {
    type: String,
    required: true,
  },
  dsr: {
    type: String,
    required: true,
  },
  countDown: {
    type: String,
  },
  nationality: {
    type: String,
  },
  grossSalary: {
    type: Number,
  },
  type: {
    type: String,
  },
  preStatus: {
    type: String,
  },
  changeApplicationFlag: {
    type: Boolean,
    default: false,
  },
  token: {
    type: String,
    required: true,
  },
  isDraft: {
    type: Boolean,
    default: false,
  },
  acc: {
    type: String,
  },
  date: {
    type: String,
  },
  time: {
    type: String,
    default: "",
  },
});

const page = ref("acknowledgement");
</script>

<style scoped>
.progressContainer {
  max-width: 1440px;
  margin: auto;
  padding: 4% 10%;
  background: #fff;
}

.content {
  display: flex;
  justify-content: center;
  margin: 0;
}

.top-up-successful,
.top-up-successful * {
  margin-top: 20px;
  box-sizing: border-box;
}
.top-up-successful {
  color: var(--primary-active, #ac2887);
  text-align: center;
  font: 500 22px/130% "outfit";
  position: relative;
  align-self: stretch;
}

@media (max-width: 500px) {
}

.progressContainer:is(.Mobile) {
  max-width: 1440px;
  margin: auto;
  padding: 0;
  background: #fff;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 110%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  will-change: transform, opacity;
  transform: translateZ(0);
  overflow-y: hidden;
  transition: top 0.3s;
}
.loading {
  margin-bottom: 0;
  font-family: "Outfit";
  color: white;
}
.spinner-border {
  width: 5rem;
  height: 5rem;
  color: white;
}
.flex-container {
  left: 0;
  margin: auto;
  position: absolute;
  text-align: center;
  top: 35%;
  right: 30%;
  left: 30%;
}
</style>
